import React from 'react';
import Icon from '../assets/img/triangle.png';
import Slider from '@material-ui/core/Slider';
import DateFnsUtils from '@date-io/date-fns';
import { format, parse } from 'date-fns'
import 'date-fns';
import {
    MuiPickersUtilsProvider,
    DatePicker
} from '@material-ui/pickers';
import { FilterArchive } from '../models/card';
import { MaterialUiPickersDate } from '@material-ui/pickers/typings/date';

interface DropdownState {
    isShow?: boolean;
    selectData?: string;
    dropdownList: any[];
    value: any[];
    isCalendarOpen: boolean;
}

interface DropdownProps {
    setFilter?: Function;
    className?: string;
    type?: string;
    filter: FilterArchive;
}

class DropdownRange extends React.PureComponent<DropdownProps, DropdownState> {
    private wrapperRef: any;
    constructor(props: DropdownProps) {
        super(props);
        this.state = { isShow: false, isCalendarOpen: false, selectData: 'Range', value: [0, 12400000], dropdownList: [{ checked: false, value: 'การเมือง' }, { checked: false, value: 'การเศรษบกิจ' }, { checked: false, value: 'สังคม' }, { checked: false, value: 'การศึกษา' }] };
        this.wrapperRef = React.createRef();
        this.handleChange = this.handleChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event: any) => {
        const {isCalendarOpen, isShow} = this.state;
        if (this.wrapperRef && !this.wrapperRef.current.contains(event.target) && !isCalendarOpen && isShow) {
            this.setState({ isShow: false });
        }
    }

    openDropDown = () => {
        const { isShow } = this.state;
        this.setState({ isShow: !isShow });
    }

    handleChange = (event: any, newValue: any) => {
        const filter = { ...this.props.filter };
        filter.noOfTweetsStart = newValue[0];
        filter.noOfTweetsEnd = newValue[1];
        this.setState({ value: newValue });
        this.props?.setFilter && this.props.setFilter(filter, 'noOfTweets');
    };

    handleDateChange = (date: any, type: string) => {
        const dateFormat = format(date, 'dd/MM/yyyy');
        const filter = { ...this.props.filter };
        if (type === 'startDate') {
            filter.startDate = dateFormat;
            this.setState({isCalendarOpen: false});
        }
        if (type === 'endDate') {
            filter.endDate = dateFormat;
            this.setState({isCalendarOpen: false});
        }
        this.props?.setFilter && this.props.setFilter(filter, 'date');
    }

    handleOpenCalendar = () => {
        const isCalendar = this.state.isCalendarOpen;
        this.setState({ isCalendarOpen: !isCalendar });
    }

    render() {
        const { isShow, selectData, value } = this.state;
        const { endDate, startDate } =this.props.filter;
        const { filter } = this.props;
        const minDate = parse('02/07/2020', 'dd/MM/yyyy', new Date());
        const maxDate = parse('31/05/2021', 'dd/MM/yyyy', new Date());
        const rangeOfTweets: number[] = [filter.noOfTweetsStart, filter.noOfTweetsEnd];
        return (<React.Fragment>
            <div className={`${this.props.className}`}>
                <div ref={this.wrapperRef} className={`dropdown-container`} >
                    <div onClick={() => { this.openDropDown() }} className="dropdown-select">
                        {selectData} <span><img src={Icon} alt='logo-e' /> </span>
                    </div>
                    {
                        isShow &&
                        (
                            <div className="dropdown-container-list" style={{ padding: '20px', marginTop: '10px', border: '1px solid black', position: 'absolute', width: '300px', height: '300px', zIndex: 99, backgroundColor: 'white', overflow: 'auto', maxHeight: '500px' }}>
                                Volume
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div>{value[0]}</div>
                                    <div>{value[1]}</div>
                                </div>
                                <Slider
                                    value={rangeOfTweets}
                                    onChange={this.handleChange}
                                    step={100}
                                    valueLabelDisplay={'off'}
                                    max={12400000}
                                    aria-labelledby="range-slider"
                                    getAriaValueText={(value: any) => value}
                                />
                                <div onClick={() => {this.setState({isCalendarOpen: true})}}>
                                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                                        <div> ตั้งแต่ </div>
                                        <DatePicker
                                            disableToolbar
                                            variant="dialog"
                                            margin="normal"
                                            format="dd/MM/yyyy"
                                            id="date-picker-start"
                                            emptyLabel={''}
                                            minDate={minDate}
                                            maxDate={maxDate}
                                            value={parse(startDate, 'dd/MM/yyyy', new Date())}
                                            onChange={(e: MaterialUiPickersDate) => { this.handleDateChange(e, 'startDate') }}
                                        />
                                        <div> ถึง</div>
                                        <DatePicker
                                            disableToolbar
                                            variant="dialog"
                                            format="dd/MM/yyyy"
                                            margin="normal"
                                            id="date-picker-end"
                                            emptyLabel={''}
                                            minDate={minDate}
                                            maxDate={maxDate}
                                            value={parse(endDate, 'dd/MM/yyyy', new Date())}
                                            onChange={(e: MaterialUiPickersDate) => { this.handleDateChange(e, 'endDate') }}
                                        />
                                    </MuiPickersUtilsProvider>
                                </div>
                            </div>
                        )
                    }
                </div>
            </div>
        </React.Fragment>
        );
    }
}

export default DropdownRange;